/**
 * @see mobiz-backend:IMobizExtensionHostRegistry.RegisterNotificationEventHandler()
 * @see mobiz-posturinn-extension:Posturinn.Extension.Service.Postal.Notifications.NotificationEvents
 */
export const enum NotificationEvents {
  /** @deprecated The Postur.FYI value will be removed in the future. */
  FYI = 'Postur.FYI',
  AutomaticPaymentFailure = 'Posturinn.AutomaticPaymentFailure',
  AutomaticPaymentFailureReminder = 'Posturinn.AutomaticPaymentFailureReminder',
  AutomaticPaymentSuccess = 'Posturinn.AutomaticPaymentSuccess',
  HomeDeliveryCapitalInProgress = 'Posturinn.HomeDeliveryCapitalInProgress',
  HomeDeliveryCapitalInvalidRecipientAddress = 'Posturinn.HomeDeliveryCapitalInvalidRecipientAddress',
  HomeDeliveryCapitalNoBodyHome = 'Posturinn.HomeDeliveryCapitalNoBodyHome',
  HomeDeliveryDriverFailure = 'Posturinn.HomeDeliveryDriverFailure',
  HomeDeliveryRuralInProgress = 'Posturinn.HomeDeliveryRuralInProgress',
  HomeDeliveryRuralInvalidRecipientAddress = 'Posturinn.HomeDeliveryRuralInvalidRecipientAddress',
  HomeDeliveryRuralNoBodyHome = 'Posturinn.HomeDeliveryRuralNoBodyHome',
  HomeDeliveryRuralPostOfficeInProgress = 'Posturinn.HomeDeliveryRuralPostOfficeInProgress',
  HomeDeliveryRuralPostOfficeInvalidRecipientAddress = 'Posturinn.HomeDeliveryRuralPostOfficeInvalidRecipientAddress',
  HomeDeliveryRuralPostOfficeNoBodyHome = 'Posturinn.HomeDeliveryRuralPostOfficeNoBodyHome',
  InboundDomesticShipmentArrived = 'Posturinn.InboundDomesticShipmentArrived',
  InboundInternationalShipmentArrived = 'Posturinn.InboundInternationalShipmentArrived',
  InboundInternationalShipmentMissingCustomsInfo = 'Posturinn.InboundInternationalShipmentMissingCustomsInfo',
  InboundInternationalShipmentMissingCustomsInfoReminder24h = 'Posturinn.InboundInternationalShipmentMissingCustomsInfoReminder24h',
  InboundInternationalShipmentMissingCustomsInfoReminder48h = 'Posturinn.InboundInternationalShipmentMissingCustomsInfoReminder48h',
  ParcelPointShipmentMovedToPostOffice = 'Posturinn.ParcelPointShipmentMovedToPostOffice',
  ParcelPointShipmentReady = 'Posturinn.ParcelPointShipmentReady',
  ParcelPointShipmentReadyReminder24h = 'Posturinn.ParcelPointShipmentReadyReminder24h',
  ParcelPointShipmentReadyReminder48h = 'Posturinn.ParcelPointShipmentReadyReminder48h',
  PaymentMissing = 'Posturinn.PaymentMissing',
  PostBoxShipmentMovedToPostOffice = 'Posturinn.PostBoxShipmentMovedToPostOffice',
  PostBoxShipmentReady = 'Posturinn.PostBoxShipmentReady',
  PostBoxShipmentReadyReminder24h = 'Posturinn.PostBoxShipmentReadyReminder24h',
  PostBoxShipmentReadyReminder48h = 'Posturinn.PostBoxShipmentReadyReminder48h',
  PostOfficeShipmentReady = 'Posturinn.PostOfficeShipmentReady',
  PostOfficeShipmentReadyReminder5d = 'Posturinn.PostOfficeShipmentReadyReminder5d',
  PostOfficeShipmentReadyReminder7d = 'Posturinn.PostOfficeShipmentReadyReminder7d',
}
